import { useCognitoAuth } from '@/contexts/cognitoAuthContext'
import { useGetStoreLocations } from '@/queries/storeLocations/useGetStoreLocations'
import { PATHS } from '@/routes/PATHS'
import { Navigate, Outlet } from 'react-router'

interface OpenTableProtectedRoutesProps {
  pathname: string
}

export function OpenTableProtectedRoutes({ pathname }: OpenTableProtectedRoutesProps) {
  const { isAuthenticated } = useCognitoAuth()
  const { data, isLoading } = useGetStoreLocations({ enabled: isAuthenticated })

  // Wait until locations are loaded to make a decision
  if (isLoading) return null

  const hasStoreLocations = Array.isArray(data) && data.length > 0

  if (!hasStoreLocations && PATHS.noLocations !== pathname) {
    return <Navigate to={PATHS.noLocations} replace />
  }

  if (hasStoreLocations && PATHS.noLocations === pathname) {
    return <Navigate to={PATHS.homePage} replace />
  }

  return <Outlet />
}
